import { sponsorAxiosInstance } from './base-service';
import { PassPolicy } from '../models/IPassPolicy';
import { AxiosResponse } from 'axios';
import { PassRequest, SwooshRegistrationLink, UpdatePassRequest } from 'models/IPassRequest';
import { VisitorPass, VisitorPasses } from '../models/IVisitorPass';
import { Reservation } from '../models/IReservation';
import { FamilyRelationship } from '../models/IRelationShips';

export const GetPassPolicies = (
  sponsorId: number | undefined,
): Promise<AxiosResponse<PassPolicy[]>> => {
  return sponsorAxiosInstance.get<PassPolicy[]>(`v1/Sponsor/${sponsorId}/PassPolicies`);
};
export const getPassesByPageAndFilter = (
  sponsorId: number | undefined,
  pageNum: number,
  pageSize: number,
  passType: number | null,
  activeOrAll: any,
): Promise<AxiosResponse<VisitorPasses>> => {
  return sponsorAxiosInstance.get<VisitorPasses>(
    `v1/Sponsor/${sponsorId}/VisitorPasses?pageNumber=${pageNum}&pageSize=${pageSize}&visitTypes=${passType}&VisitStatus=${activeOrAll}`,
  );
};

export const registerPass = (sponsorId: number | undefined, pass: PassRequest) => {
  return sponsorAxiosInstance.post(`v1/Sponsor/${sponsorId}/passes`, pass);
};
export const CancelPass = (passId: number | undefined): Promise<AxiosResponse<void>> => {
  return sponsorAxiosInstance.put<void>(`/v1/Pass/${passId}/Cancel`);
};
export const ResendEmail = (
  passId: number | undefined,
  emailAddress: string | undefined,
): Promise<AxiosResponse<void>> => {
  return sponsorAxiosInstance.put<void>(
    `/v1/passes/${passId}/resend`,
    JSON.stringify(emailAddress),
  );
};
export const SendEmployeeEmail = (sponsorId: number | undefined): Promise<AxiosResponse<void>> => {
  return sponsorAxiosInstance.post<void>(`/v1/Sponsor/SendEmployeeEmail`, sponsorId);
};
export const GetEmployeePass = (
  sponsorId: number | undefined,
): Promise<AxiosResponse<VisitorPass>> => {
  return sponsorAxiosInstance.get<VisitorPass>(`/v1/Sponsor/Pass/${sponsorId}`);
};
export const GetPolicyShoppingTimes = (
  passpolicyId: number,
  storeId: number,
  date: string,
): Promise<AxiosResponse<Reservation>> => {
  const reservationUri =
    '/passpolicy/' + passpolicyId + '/reservations/v1/' + storeId + '?date=' + date;
  return sponsorAxiosInstance.get<Reservation>(reservationUri);
};
export const GetEmployeePassV2 = (
  sponsorId: number | undefined,
): Promise<AxiosResponse<VisitorPass[]>> => {
  return sponsorAxiosInstance.get<VisitorPass[]>(`/v1/Sponsor/${sponsorId}/EmployeePasses/`);
};

export const InactivatePass = (passId: number | undefined): Promise<AxiosResponse<void>> => {
  return sponsorAxiosInstance.put<void>(`/v1/Pass/${passId}/Inactive`);
};

export const GetRegistrationLink = (
  sponsorId: number | undefined,
  passId: number | undefined,
): Promise<AxiosResponse<SwooshRegistrationLink>> => {
  return sponsorAxiosInstance.get<SwooshRegistrationLink>(
    `/v1/Sponsor/${sponsorId}/Passes/${passId}/RegistrationLink`,
  );
};

export const UpdatePasses = (sponsorId: number | undefined, pass: UpdatePassRequest) => {
  return sponsorAxiosInstance.post(`v1/Sponsor/${sponsorId}/passes`, pass);
};
export const GetFamilyPass = (
  sponsorId: number | undefined,
): Promise<AxiosResponse<VisitorPass[]>> => {
  return sponsorAxiosInstance.get<VisitorPass[]>(`/v1/Sponsor/${sponsorId}/FamilyPasses/`);
};

export const GetFamilyRelationships = (
  sponsorId: number | undefined,
): Promise<AxiosResponse<FamilyRelationship[]>> => {
  return sponsorAxiosInstance.get<FamilyRelationship[]>(
    `/v1/Sponsor/${sponsorId}/FamilyRelationships`,
  );
};

// This function is used to resend the email for a specific passId
export const ResendEmailByPassId = (passId: number) => {
  return sponsorAxiosInstance.put<void>(`/v1/passes/${passId}/resend`, null);
};
